'use client'

import type React from 'react'
import { useState, forwardRef } from 'react'
import { cn } from '@dc-shared-web/lib'
import { faEye, faEyeSlash } from '@document-crunch/pro-regular-svg-icons'
import { Icon } from '@dc-shared-web/components/base/Icon'
import { Input } from '@dc-shared-web/components/shadcn/input'
import { Button } from '@dc-shared-web/components/shadcn/button'

export interface PasswordInputProps
  extends Omit<React.ComponentPropsWithoutRef<typeof Input>, 'size'> {
  wrapperClassName?: string
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ wrapperClassName, className, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
      <div className={cn('tw-relative', wrapperClassName)}>
        <Input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          className={cn('tw-z-0', className)}
          inputClassName='tw-pr-10'
          {...props}
        />
        <div className='tw-absolute tw-inset-y-0 tw-right-0 tw-z-10'>
          <Button
            type='button'
            variant='primitive'
            size='sm'
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <Icon icon={faEyeSlash} /> : <Icon icon={faEye} />}
          </Button>
        </div>
      </div>
    )
  }
)

PasswordInput.displayName = 'PasswordInput'
